type N = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
type Scale = 50 | 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | 950

type SolidNeutral = `solid/neutral/${N}`
type SolidAccent = `solid/accent/${"mint" | "yellow" | "fuschia" | "marigold" | "light grey" | "grey"}`
type SolidGreen = `solid/green/${Scale}`
type SolidYellow = `solid/yellow/${Scale}`
type SolidRed = `solid/red/${Scale}`
type SolidBrandComposite = `solid/brand/composite/${N}`
type AlphaNeutral = `alpha/neutral/${N}`
type AlphaOverlay = `alpha/overlay/${"white" | "black"}`
type AlphaBrand = `alpha/brand/${N}`

export type ColorToken =
  | "white"
  | "black"
  | SolidNeutral
  | SolidAccent
  | SolidGreen
  | SolidYellow
  | SolidRed
  | SolidBrandComposite
  | AlphaNeutral
  | AlphaOverlay
  | AlphaBrand

export function colorTokenToVar(token: ColorToken): string {
  return `var(--ds-${token.replace(/\//g, "-").replace(/\s+/g, "-")})`
}
